<template>
  <div id="document-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        config-module="120"
        :reset="true"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <template slot="operations">
          <!--查看-->
          <el-button :disabled="!selectedJob || total <= 0" type="success" no="1" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
          <!--编辑-->
          <el-button :disabled="!(selectedJob && Number(selectedJob.jobState) === 0 && !JobUtils.isBlockJob(selectedJob))" type="success" no="2" @click="toEdit()">{{ $t('common.btn.edit') }}</el-button>
          <!--重新编辑-->
          <el-button v-show="$checkPermission(['button_SEDocuments_reEdit']) || $store.getters.isAdmin" :disabled="!(selectedJob && Number(selectedJob.jobState) > 0)" type="success" no="3" @click="toEditAgain()">{{ $t('common.btn.editAgain') }}</el-button>
        </template>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          config-module="130120"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          style="width: 100%;"
          @gridReady="onGridReady"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="!appendQuery"
          config-module="130120"
          :total="total"
          :page-count="pageCount"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :selected-row-count="selectedRowCount"
          @pagination="toQuery()"
        />
      </div>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import hblIcon from '@/assets/h_resize.png'
import jobDetailIcon from '@/assets/job-detail.png'
import mblIcon from '@/assets/m_resize.png'
import { isArray } from '@/utils/validate'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { findSeaExportJobByNo, advancedQuery } from '@/api/seaExport/seaExportJob'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as BillReleaseType from '@/class/cargo/model/parameters/BillReleaseType'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'

export default {
  name: 'DocumentTreeGrid',
  components: {
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    searchItem,
    cargoTemplateSelectorDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      blModeList: [],
      filterJson: {},
      total: 0,
      pageCount: 0,
      JobUtils,
      selectedJob: null,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const currentJob = params.data
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                return false
              }
              return true
            },
            innerRenderer: params => {
              const currentJob = params.data
              if (currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
                return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
              }
              const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}<img src="${jobDetailIcon}" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" onclick="${methodPath}(event)"/></span>`
            }
          }
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        onCellDoubleClicked: event => {
          this.toLook(event.data)
        },
        onRowClicked: this.onRowClicked,
        getRowStyle: (params) => {
          const row = params.data
          const { colorSettings, colorType } = this
          if (colorType) {
            return JobUtils.financeColor(row)
          } else if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
            if (Object.prototype.hasOwnProperty.call(row, 'blocked') &&
              Object.prototype.hasOwnProperty.call(row, 'specialApproval') &&
              JobUtils.isBlockJob(row)) {
              return { 'background': colorSettings.find(item => item.colorKey === 'isBlocked').colorValue }
            } else {
              const jobState = String(row.jobState) || ''
              for (const stateColor of colorSettings) {
                if (jobState === stateColor.colorKey) {
                  return { 'background': stateColor.colorValue }
                }
              }
            }
          }
          return {}
        },
        defaultColDef: {
          resizable: true
        },
        onSortChanged: (event) => {
          // this.$logger.log('onSortChanged-event', event)
          if (this.rowDataBeforeSort.length !== this.rowData.length) {
            this.rowDataBeforeSort = this.rowData
          }
          if (!event.api.getSortModel().length) {
            this.rowData = this.rowDataBeforeSort
            this.rowDataBeforeSort = []
          } else {
            this.rowData = event.api.getModel().rowsToDisplay.map(item => item.data)
          }
        },
        context: {
          componentParent: this
        },
        onSelectionChanged: (event) => {
          const allRow = event.api.getSelectedRows()
          const selectedRows = []
          for (const row of allRow) {
            if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
              selectedRows.push(row)
            }
          }
          this.selectedRowCount = selectedRows.length
        }
      },
      selectedRowCount: 0,
      columnDefs: [
        // 显示列
        {
          headerName: this.$t('SeaExport.ConsignationRelationNumber'),
          colId: 'trustFromJob',
          field: 'trustFromJob',
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
          colId: 'relatedJob',
          field: 'relatedJob',
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          colId: 'customerTypeId',
          field: 'customerTypeId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContractStatus'),
          colId: 'contractStatus',
          field: 'contractStatus',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RiskReason'),
          colId: 'riskReason',
          field: 'riskReason',
          width: 150
        }, {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          colId: 'cargoSalesId',
          field: 'cargoSalesId',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: 'customerId',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.PortOfLoading'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          width: 170
        }, {
          headerName: this.$t('SeaExport.TransitPort'),
          colId: 'transferPortCode',
          field: 'transferPortCode',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          colId: 'dischargingPortCode',
          field: 'dischargingPortCode',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          width: 170
        }, {
          headerName: this.$t('SeaExport.ConsignationStatus'),
          colId: 'crossTenantHistoryState',
          field: 'crossTenantHistoryState',
          cellRenderer: (params) => {
            return ColumnUtils.crossTenantHisStateCommonFun(params.data, params.value)
          },
          filter: false,
          filterParams: {},
          width: 150
        }, {
          headerName: this.$t('SeaExport.ConsignationStatusTime'),
          colId: 'crossTenantHistoryStateDate',
          field: 'crossTenantHistoryStateDate',
          width: 150
        }, {
          headerName: this.$t('SeaExport.PlaceOfDelivery'),
          colId: 'destinationPortCode',
          field: 'destinationPortCode',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.AirlineArea'),
          field: 'regionName',
          colId: 'regionName',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ServiceCode'),
          field: 'vesselLineCode',
          colId: 'vesselLineCode',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
          field: 'scNo',
          colId: 'scNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture'),
          field: 'etd',
          colId: 'etd',
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfArrival'),
          field: 'eta',
          colId: 'eta',
          width: 150
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualDateOfLeavingBerth'),
          field: 'actualUnBerthPlanDate',
          colId: 'actualUnBerthPlanDate',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerSelfRelease'),
          field: 'customerSelfRelease',
          colId: 'customerSelfRelease',
          cellRenderer: (params) => {
            return ColumnUtils.getCustomerSelfReleaseFunction(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CYCutOffDate2'),
          field: 'customCutoff',
          colId: 'customCutoff',
          width: 150
        }, {
          headerName: this.$t('SeaExport.DocCutOffDate'),
          field: 'fileCutoff',
          colId: 'fileCutoff',
          width: 150
        }, {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'jobNo5',
          colId: 'jobNo5',
          width: 150
        }, {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.CarrierAgent'),
          field: 'carrierAgentId',
          colId: 'carrierAgentId',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ShippingCompany'),
          field: 'carrierId',
          colId: 'carrierId',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.HaulageCompany'),
          field: 'carryingCmp',
          colId: 'carryingCmp',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.Vessel'),
          field: 'vessel',
          colId: 'vessel',
          width: 150
        }, {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 150
        }, {
          headerName: this.$t('SeaExport.BookingNo'),
          field: 'bookingNo',
          colId: 'bookingNo',
          width: 150
        }, {
          headerName: this.$t('SeaExport.MasterBillNo'),
          field: 'mbl',
          colId: 'mbl',
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          field: 'customerRefNo',
          colId: 'customerRefNo',
          width: 150
        }, {
          headerName: this.$t('SeaExport.DestinationAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'englishName') : ''
          },
          width: 200
        }, {
          headerName: this.$t('queryJob.receivablesWriteOfStatus'),
          colId: 'verifyStateReceivable',
          field: 'verifyStateReceivable',
          width: 150,
          hide: true
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNos',
          colId: 'containerNos',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Warehouse'),
          field: 'warehouseCmp',
          colId: 'warehouseCmp',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.CommissionedNumberOfPackages'),
          field: 'quantityContract',
          colId: 'quantityContract',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CommissionedGrossWeight'),
          field: 'weightContract',
          colId: 'weightContract',
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CommissionedVolume'),
          field: 'cubageContract',
          colId: 'cubageContract',
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityActual',
          colId: 'quantityActual',
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightActual',
          colId: 'weightActual',
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageActual',
          colId: 'cubageActual',
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          field: 'chargeWeight',
          colId: 'chargeWeight',
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.FLCLType'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          cellRenderer: (params) => {
            console.log(params)
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          },
          /* 设置列筛选功能的过滤器 */
          filter: false,
          filterParams: {},
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          field: 'cargoSource',
          colId: 'cargoSource',
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.LocalService'),
          field: 'loadingTerm',
          colId: 'loadingTerm',
          cellRenderer: (params) => {
            return ColumnUtils.loadingTermNewLabelFunction(params.data, params.value)
          },
          /* 设置列筛选功能的过滤器 */
          filter: false,
          filterParams: {},
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContractRateProperty'),
          field: 'bookingTerm',
          colId: 'bookingTerm',
          cellRenderer: (params) => {
            return ColumnUtils.bookingTermLabelFunction(params.data, params.value)
          },
          /* 设置列筛选功能的过滤器 */
          filter: false,
          filterParams: {},
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.IssueMethod'),
          field: 'mblOnly',
          colId: 'mblOnly',
          cellRenderer: (params) => {
            return ColumnUtils.mblOnlyLabelFunction(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          colId: 'warehouseNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ItemNo'),
          field: 'poNo',
          colId: 'poNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          colId: 'soNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.TradeMethod'),
          field: 'tradeTerm',
          colId: 'tradeTerm',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TradeTerm, 'code', params.value, 'name')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          colId: 'incoTerm',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MasterBLFreightTerm'),
          field: 'paymentTermMBL',
          colId: 'paymentTermMBL',
          cellRenderer: (params) => {
            return ColumnUtils.paymentTermLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLFreightClause'),
          field: 'paymentTermHBL',
          colId: 'paymentTermHBL',
          cellRenderer: (params) => {
            return ColumnUtils.paymentTermLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MBLTransportationClause'),
          field: 'freightTerm',
          colId: 'freightTerm',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLTransportationClause'),
          field: 'freightTermHBL',
          colId: 'freightTermHBL',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          cellRenderer: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ContainerNumberSealNumber'),
          colId: 'tmpContainerNo',
          field: 'tmpContainerNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MBLSplitNo'),
          field: 'mBLSplitNo',
          colId: 'mBLSplitNo',
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLSplitNo'),
          field: 'hBLSplitNo',
          colId: 'hBLSplitNo',
          width: 150
        }, {
          headerName: this.$t('SeaExport.HarborDistrict'),
          field: 'portDistrict',
          colId: 'portDistrict',
          width: 150
        }, {
          headerName: this.$t('SeaExport.SOPStatus'),
          field: 'sopState',
          colId: 'sopState',
          width: 150,
          tooltipValueGetter: (params) => params.value
        }, {
          headerName: 'HDS',
          colId: 'hds',
          field: 'hds',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 150
        }, {
          headerName: 'TEU',
          colId: 'teu',
          field: 'teu',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          colId: 'sales',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Accrued'),
          field: 'provisioned',
          colId: 'provisioned',
          cellRenderer: params => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          colId: 'csr',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Documents'),
          field: 'dc',
          colId: 'dc',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.AirlinePerson'),
          field: 'planner',
          colId: 'planner',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BusinessCreator'),
          field: 'createdBy',
          colId: 'createdBy',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.CYOpeningDate'),
          field: 'terminalOpenDate',
          colId: 'terminalOpenDate',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CYCutOffDate'),
          field: 'terminalCutoff',
          colId: 'terminalCutoff',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CargosExpectedArrivalDate'),
          field: 'loadingDate',
          colId: 'loadingDate',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ShutOut'),
          field: 'shutOut',
          colId: 'shutOut',
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Status'),
          field: 'jobState',
          colId: 'jobState',
          cellRenderer: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.getJobStateForBlock(params.data)
          },
          width: 150
        }, {
          headerName: 'HBL NO',
          field: 'hblNo',
          colId: 'hblNo',
          width: 150
        }, {
          headerName: this.$t('SeaExport.PortCodeOfDischarge'),
          field: 'portCode',
          colId: 'portCode',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.AirlineCode'),
          field: 'laneCode',
          colId: 'laneCode',
          width: 150
        }, {
          headerName: this.$t('SeaExport.DangerousGoodsClassification'),
          field: 'danClassNo',
          colId: 'danClassNo',
          hide: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.DangerousGoodsUNNo'),
          field: 'danUNNo',
          colId: 'danUNNo',
          hide: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.CustomsBroker'),
          field: 'customsBroker',
          colId: 'customsBroker',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') : ''
          },
          hide: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.FinalDestination'),
          hide: true,
          field: 'destinationPlace',
          colId: 'destinationPlace',
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLConsignee'),
          field: 'hBLConsignee',
          colId: 'hBLConsignee',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLShipper'),
          field: 'shipperCode',
          colId: 'shipperCode',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CargoType'),
          field: 'cargoType',
          colId: 'cargoType',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomJobType'),
          field: 'customJobType',
          colId: 'customJobType',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'chineseName')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.OperationTips'),
          field: 'operationTips',
          colId: 'operationTips',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          colId: 'remarks',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          field: 'userDefinedField1',
          colId: 'userDefinedField1',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          field: 'userDefinedField2',
          colId: 'userDefinedField2',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          field: 'userDefinedField3',
          colId: 'userDefinedField3',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          colId: 'cargoChineseName',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          field: 'cargoEnglishName',
          colId: 'cargoEnglishName',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MBLBlType'),
          field: 'mblReleaseType',
          colId: 'mblReleaseType',
          cellRenderer: (params) => {
            return ColumnUtils.MBLBlTypeLabelFunc(TYPE_NAMES.basic_data_BlMode, params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: 'MBL' + this.$t('SeaExport.BlProperty'),
          field: 'typeMBL',
          colId: 'typeMBL',
          cellRenderer: (params) => {
            return ColumnUtils.typeMBLLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: 'HBL' + this.$t('SeaExport.BlProperty'),
          field: 'typeHBL',
          colId: 'typeHBL',
          cellRenderer: (params) => {
            return ColumnUtils.typeHBLLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: 'HBL' + this.$t('SeaExport.SerialNo'),
          field: 'serialNo',
          colId: 'serialNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MBLCheckingStatus'),
          field: 'mblCfmState',
          colId: 'mblCfmState',
          cellRenderer: (params) => {
            return ColumnUtils.cfmStatusLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.MBLReleasingStatus'),
          colId: 'mblReleaseState',
          field: 'mblReleaseState',
          cellRenderer: (params) => {
            return ColumnUtils.releaseStateLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLBlType'),
          colId: 'hblReleaseType',
          field: 'hblReleaseType',
          cellRenderer: (params) => {
            return ColumnUtils.HBLBlTypeLabelFunc(TYPE_NAMES.basic_data_BlMode, params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: 'HBL' + this.$t('SeaExport.BlType2'),
          field: 'hblIssuerBL',
          colId: 'hblIssuerBL',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OrderFormType, 'code', params.value, 'name')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLCheckingStatus'),
          colId: 'hblCfmState',
          field: 'hblCfmState',
          cellRenderer: (params) => {
            return ColumnUtils.cfmStatusLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HBLReleasingStatus'),
          colId: 'hblReleaseState',
          field: 'hblReleaseState',
          cellRenderer: (params) => {
            return ColumnUtils.releaseStateLabelFunc(params.value)
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Consignee'),
          colId: 'consigneeLine1',
          field: 'consigneeLine1',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Shipper'),
          field: 'shipperLine1',
          colId: 'shipperLine1',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.NotifyParty'),
          field: 'notifyLine1',
          colId: 'notifyLine1',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.OperationDate'),
          field: 'customsDate',
          colId: 'customsDate',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.DoorAddress'),
          field: 'doorAddr',
          colId: 'doorAddr',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ArrivalTime'),
          field: 'actualArrivalTime',
          colId: 'actualArrivalTime',
          width: 150
        }, {
          headerName: this.$t('SeaExport.CustomsClearance'),
          field: 'destPortCustomsClearanceTime',
          colId: 'destPortCustomsClearanceTime',
          width: 150
        }, {
          headerName: this.$t('SeaExport.DeliveryTime'),
          field: 'destPortDeliveryTime',
          colId: 'destPortDeliveryTime',
          width: 150
        }, {
          headerName: this.$t('SeaExport.ReturnTime'),
          field: 'destPortReturnTime',
          colId: 'destPortReturnTime',
          width: 150
        }, {
          headerName: this.$t('SeaExport.UserDefinedField4'),
          field: 'userDefinedField4',
          colId: 'userDefinedField4',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.bargePOL'),
          field: 'bargePOL',
          colId: 'bargePOL',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.HsCode'),
          field: 'hsCode',
          colId: 'hsCode',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ProjectName'),
          field: 'projectName',
          colId: 'projectName',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.ProjectBatch'),
          field: 'projectBatch',
          colId: 'projectBatch',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.CargosExpectedArrivalDate'),
          field: 'arriveDate',
          colId: 'arriveDate',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.NCReferenceNo'),
          field: 'agentRefNo',
          colId: 'agentRefNo',
          hide: true,
          width: 150
        }
      ],
      columnAdds: [],
      rowData: [],
      gridApi: null,
      documentManage: new DocumentManage(),
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaExportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      lob: 'SE',
      appendQuery: false // 追加查询
    }
  },
  computed: {
    customSearchItems() { // 自定义高级查询项
      return this.getCustomSearchItems()
    },
    colorType() {
      return Number(this.$store.state.settings.colorType) === 1
    },
    colorSettings() {
      return this.$store.state.settings.colorSettings
    }
  },
  watch: {
    colorSettings: {
      handler() {
        this.gridOptions.api.redrawRows()
      },
      deep: true
    }
  },
  async created() {
    this.blModeList = await getSpecificBasicData(basicCacheKeys.basic_data_BlMode)
    await this.preloadBasicData()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 组装查询条件
    getCustomSearchItems() {
      const defaultSearchFields = []
      // 提单方式
      const billReleases = BillReleaseType.BILL_RELEASES.map(item => {
        return { code: item.serialNumber, chineseName: item.name, englishName: item.name }
      })
      const hblBillReleases = [...billReleases]
      const mblBillReleases = [...billReleases]
      if (this.blModeList && this.blModeList.length > 0) {
        for (const blMode of this.blModeList) {
          if (blMode.blType === 3) {
            hblBillReleases.push({ code: blMode.serialNumber, chineseName: blMode.localName, englishName: blMode.localName })
          }
          if (blMode.blType === 1) {
            mblBillReleases.push({ code: blMode.serialNumber, chineseName: blMode.localName, englishName: blMode.localName })
          }
        }
      }
      // MBL提单方式
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cargoDocMBL.RELEASE_TYPE'
      searchField.itemLabel = 'SeaExport.MBLBlType'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = mblBillReleases
      defaultSearchFields.push(searchField.formatObj2Json())

      // HBL提单方式
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cargoDocHBL.RELEASE_TYPE'
      searchField.itemLabel = 'SeaExport.HBLBlType'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = hblBillReleases
      defaultSearchFields.push(searchField.formatObj2Json())
      return defaultSearchFields
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    async onGridCellFocused(event) {
      if (!event) return
      this.selectedJob = null
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        if (this.gridApi && event.column) {
          this.gridApi.forEachNode(node => {
            if (node && node.rowIndex === event.rowIndex && node.data) {
              const nodeJob = node.data
              if (nodeJob.dataType && Number(nodeJob.dataType) === 1 || Number(nodeJob.dataType) === 2 && nodeJob.jobUuid) {
                this.selectedJob = nodeJob
              }
            }
          })
          // this.$logger.log('===onGridCellFocused====', this.selectedJob.jobNo + '_' + this.selectedJob.jobState)
        }
      })
    },
    // 选中 勾选框触发[获取选中行]
    onGridRowSelected(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      if (event.node.isSelected()) {
        const node = event.data
        if (node.dataType && Number(node.dataType) === 1 || Number(node.dataType) === 2 && node.jobUuid) {
          this.selectedJob = node
        }
      }
      // this.$logger.log('===onGridRowSelected====', this.selectedJob.jobNo + '_' + this.selectedJob.jobState)
    },
    onGridReady(p) {
      // console.log('gridReady', p)
      this.gridApi = p.api
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const node = event.data
      if (node.dataType && Number(node.dataType) === 1 || Number(node.dataType) === 2 && node.jobUuid) {
        this.selectedJob = node
      }
    },
    // 初始化配置参数
    async preloadBasicData() {
      await cache.load(cacheName.CONFIG)
    },
    // 查询[简单查询/高级查询]
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.loading = getLoading()
      if (typeof data !== 'undefined') {
        // 获取追加查询条件
        data.forEach((element, index) => {
          if (Object.prototype.hasOwnProperty.call(element, 'appendQuery')) {
            this.appendQuery = element.appendQuery
            data.splice(index, 1)
          }
        })
        // 高级查询条件组装
        this.filterJson.conditions = this.addConditionsBeforeQuery(data)
        this.filter.pageNum = 1
      }
      this.filterJson.appendQuery = this.appendQuery
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      if (!this.appendQuery) {
        // 追加查询不修改分页条件
        this.filterJson.pageNum = this.filter.pageNum
        this.filterJson.pageSize = this.filter.pageSize
      }

      advancedQuery(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 查询之前的条件组装
    addConditionsBeforeQuery(data) {
      if (typeof data === 'undefined') return
      if (AdvancedSearchOption.hasField('cargoDocHBL.HBL_NBR2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
      }
      if (AdvancedSearchOption.hasField('cargoDoc.HBL_NBR2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDoc.DOC_TYPE', CargoDocConsts.HBL2).formatObj2Json())
      }
      if (AdvancedSearchOption.hasField('seaCargoDoc.SUB_DOC_TYPE2', data)) {
        data.push(new AdvancedSearchOption(null, 'cargoDoc.DOC_TYPE', CargoDocConsts.MBL2).formatObj2Json())
      }
      // MBL 提单状态
      if (AdvancedSearchOption.hasField('cargoDocMBL.CFM_STATE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocMBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocMBL.DOC_TYPE', CargoDocConsts.MBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_MBL', true).formatObj2Json())
        }
      }
      // HBL 提单状态
      if (AdvancedSearchOption.hasField('cargoDocHBL.CFM_STATE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }

      // MBL 提单方式
      if (AdvancedSearchOption.hasField('cargoDocMBL.RELEASE_TYPE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocMBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocMBL.DOC_TYPE', CargoDocConsts.MBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_MBL', true).formatObj2Json())
        }
      }
      // HBL 提单方式
      if (AdvancedSearchOption.hasField('cargoDocHBL.RELEASE_TYPE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }
      // MBL 放单状态  qm
      if (AdvancedSearchOption.hasField('seaCargoDocMBL.RELEASE_TYPE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocMBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocMBL.DOC_TYPE', CargoDocConsts.MBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_MBL', true).formatObj2Json())
        }
      }
      // HBL 放单状态  qm
      if (AdvancedSearchOption.hasField('seaCargoDocHBL.RELEASE_TYPE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }

      // HBL提单类型 qm
      if (AdvancedSearchOption.hasField('cargoDocHBL.ISSUER_BL', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }
      // 客户自出单
      if (AdvancedSearchOption.hasField('seaCargoDocHBL.CUSTOMER_SELF_RELEASE', data)) {
        if (!AdvancedSearchOption.hasField('cargoDocHBL.DOC_TYPE', data)) {
          data.push(new AdvancedSearchOption(null, 'cargoDocHBL.DOC_TYPE', CargoDocConsts.HBL).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.SIGN_HBL', true).formatObj2Json())
          data.push(new AdvancedSearchOption(null, 'job.MASTER_FLAG', false).formatObj2Json())
        }
      }

      if (!AdvancedSearchOption.hasField('job.JOB_STATE', data)) {
        const jobStates = []
        for (const c of SystemConstants.JOB_STATES) {
          jobStates.push(c.code)
        }
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
        data.push(option.formatObj2Json())
      }
      const lcOption = AdvancedSearchOption.getOption('job.localSevice', data)
      if (lcOption != null) {
        const codes = lcOption.value
        const services = []
        for (const code of codes) {
          const service = CommonState.getStateByCode(SeaExportConstants.STUFFY_TYPES, code)
          if (service != null) services.push(service)
        }
        const stuffingTypes = this.convertStuffyTypeToQuery(services)
        for (const stuffing in stuffingTypes) {
          data.push(new AdvancedSearchOption(null, stuffingTypes[stuffing], true).formatObj2Json())
        }
      }
      if (AdvancedSearchOption.hasField('job.localSevice', data)) {
        AdvancedSearchOption.removeOption('job.localSevice', data)
      }
      // 如果状态追踪没有选中值则将条件移除
      if (AdvancedSearchOption.hasField('trackingInfo._multipleState_', data)) {
        const trackingInfoOption = AdvancedSearchOption.getOption('trackingInfo._multipleState_', data)
        if (trackingInfoOption) {
          const trackingInfoValue = trackingInfoOption.value.value
          if (!trackingInfoValue || (isArray(trackingInfoValue) && trackingInfoValue.length <= 0)) {
            AdvancedSearchOption.removeOption('trackingInfo._multipleState_', data)
          }
        }
      }
      return data
    },
    // 本地服务条件处理
    convertStuffyTypeToQuery(items) {
      const result = []
      for (const stuffyType of items) {
        if (stuffyType.code === 'IS') {
          result.push('job.WAREHOUSING')
        } else if (stuffyType.code === 'DD') {
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'SD') {
          result.push('job.SELF_DELIVER')
        } else if (stuffyType.code === 'CT') {
          result.push('seaJob.CUSTOMS')
        } else if (stuffyType.code === 'HT') {
          result.push('seaJob.HEATING')
        } else if (stuffyType.code === 'CIT') {
          result.push('seaJob.COMERCIAL_INSPECTATION')
        } else if (stuffyType.code === 'AMS') {
          result.push('seaJob.AMS')
        } else if (stuffyType.code === 'ISBOOKING') {
          result.push('job.BOOKING')
        }
      }
      return result
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.appendQuery = false // 关闭追加查询
      this.loading = getLoading()
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      this.$logger.log('this.filter', this.filter)
      this.filter.branchId = this.$store.getters.currentOfficeId
      findSeaExportJobByNo(this.filter).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      if (res.data.notRefresh) {
        return
      }
      if (!res.data.list) {
        res.data = res.data.pageInfo
      }
      let results = res.data.list
      // 追加查询数据去重
      if (this.appendQuery) {
        const idSet = this.rowData.reduce((acc, v) => {
          acc[v.uuid] = true
          return acc
        }, {})
        const list = results.filter(v => !idSet[v.uuid])
        results = [...this.rowData, ...list]
      } else {
        this.pageCount = res.data.pages
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }
      // 对返回结果进行排序放在后端 getJobsBySort 方法
      this.rowData = results
      this.selectedRowCount = 0
      this.gridApi.clearFocusedCell()
    },
    // 查看
    toLook(row) {
      if (!row) {
        row = this.selectedJob || this.readSelectedRows()[0]
      }
      this.$emit('look', row)
    },
    // 获取选中行 dataType 区分拆并单数据 业务数据，1 主票 2 小票 3 MBL 4 MBL2 5 HBL2
    readSelectedRows() {
      const allRows = this.gridApi.getSelectedRows()
      const rows = []
      for (const row of allRows) {
        if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
          rows.push(row)
        }
      }
      if (rows.length === 0) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      return rows
    },
    // 编辑
    async toEdit() {
      const row = this.selectedJob || this.readSelectedRows()[0]
      if (row == null) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      if (row.jobState !== 0) {
        this.$message.warning(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await this.checkCanEdit(row)) {
        return
      }
      this.$emit('edit', row)
    },
    async checkCanEdit(row) {
      const userId = this.$store.getters.userId
      if (this.$store.getters.isAdmin) {
        return true
      }
      if (row && (row.dc === userId || row.op === userId)) {
        return true
      }
      if (this.$checkPermission(['role_editAllBusiness'])) {
        return true
      }
      if (this.$checkPermission(['role_DepartmentEdit'])) {
        const flag = await SecurityUtil.hasSpecificDepartmentEdit(row, { 'op': true, 'dc': true })
        if (!flag) {
          this.$message.warning(this.$t('Message.NotGroupBusinessesCannotBeEdit'))
          return false
        } else {
          return true
        }
      }
      this.$message.warning(this.$t('Message.DocumentEditedTips'))
      return false
    },
    // 重新编辑
    toEditAgain() {
      const row = this.selectedJob || this.readSelectedRows()[0]
      if (row == null) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      this.$emit('edit', row)
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      // TemplateSelectorWin.getInstance().showThisWin(data as AbstractEntity, "JOB_DETAIL_OP", {"JOB_UUID":data.key}, FlexGlobals.topLevelApplication as DisplayObject);
      if (!this.selectedJob) return
      this.templateSelectorDialog.ctx = new SeaExportJob(this.selectedJob)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 选中父级自动勾选子集，取消选中类似
    treeDataRowSelectedCallBack(p) {
      // return
      if (p.data.root) {
        if (p.node.selected) {
          p.node.childrenAfterGroup.forEach((node) => {
            node.setSelected(p.node.selected)
          })
        } else {
          const isTrue = p.node.childrenAfterGroup.filter(
            (node) => node.selected
          )
          if (isTrue.length === p.node.childrenAfterGroup.length) {
            p.node.childrenAfterGroup.forEach((node) => {
              node.setSelected(p.node.selected)
            })
          }
        }
      } else {
        if (!p.node.selected) {
          if (p.node.parent.selected) {
            p.node.parent.setSelected(false)
          }
        } else {
          const brothers = p.node.parent.childrenAfterGroup
          const selected = brothers.filter((node) => node.selected)
          if (selected.length === brothers.length) {
            p.node.parent.setSelected(true)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
#app #document-tree-grid {
  .not-click {
    pointer-events: none;
    button {
      color: #fff;
      background-color: #8cc8ff;
      border-color: #acbcca;
      cursor: not-allowed;
    }
  }
  button.not-click {
    color: #fff;
    background-color: #8cc8ff;
    border-color: #8cc8ff;
    cursor: not-allowed;
  }
}
</style>
